import { render } from "./App.vue?vue&type=template&id=deb8eb7e"
const script = {}

import "./App.vue?vue&type=style&index=0&id=deb8eb7e&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__